import { render, staticRenderFns } from "./AcceptInvitePage.vue?vue&type=template&id=0c670d36&scoped=true&"
import script from "./AcceptInvitePage.vue?vue&type=script&lang=js&"
export * from "./AcceptInvitePage.vue?vue&type=script&lang=js&"
import style0 from "./AcceptInvitePage.vue?vue&type=style&index=0&id=0c670d36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c670d36",
  null
  
)

export default component.exports